import styled from "styled-components"
import { Cookie } from "./CookieBanner.styles"
import Link from 'next/link'
import Button from "../styles/StyledButton"

export default function CookieBannerBottom ({ visible, showSettings, onOk, onCancel }) {

  return (
    <Wrapper visible={visible}>
      <Content visible={visible}>
        <Cookie.Title style={{ margin: 0 }}>Cookie handling</Cookie.Title>
        <RightPart>
          <Cookie.Text>Cookies are used to ensure the convenience of the site.</Cookie.Text>
          <Cookie.Text>By clicking "Accept", you consent to the processing of data in accordance with           
            <Link style={{ color: '#1B48B1', marginLeft: '1em' }} href={'/cookie-policy'} target="_blank">
              <Cookie.Link>Cookie Policy.</Cookie.Link>
            </Link></Cookie.Text>
        </RightPart>
        <ButtonsWrapper gap={10}>
          <Button className="cookies-consent-button" style={{ height: '100%', padding: '10px 15px', borderRadius: 20 }} light onClick={showSettings}>Set up</Button>
          <Button className="cookies-consent-button" style={{ height: '100%', padding: '10px 15px', borderRadius: 20 }} onClick={onOk}>Accept</Button>
          <Button className="cookies-consent-button" style={{ height: '100%', padding: '10px 15px', borderRadius: 20 }} onClick={onCancel}>Reject</Button>
        </ButtonsWrapper>
      </Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100vw;
  position: fixed;
  z-index: 1000000000000;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 30px 40px;
  display: ${props => props.visible ? 'flex' : 'none'};
  gap: 20px;
  flex-direction: row;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

  @media screen and (max-width: 650px) {
    padding: 20px;
  }
`

const Content = styled.div`
  gap: 1.3em;
  width: 100%;
  max-width: 1500px;
  margin: auto;
  background: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  transform: ${props => props.visible ? 'translateX(0)' : 'translateX(-40px)'};
  opacity: ${props => props.visible ? 1 : 0};
  transition: all 300ms ease;
  @media screen and (max-width: 650px) {
    flex-direction: column;
  }
`

const RightPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: calc(100% - 320px);
  @media screen and (max-width: 900px) {
    width: 100%;
  }
`

const ButtonsWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 40px;
  max-width: 700px;
  margin: auto;
  gap: 1em;
  @media screen and (max-width: 650px) {
    display: flex;
    flex-direction: column;
    gap: 0;
    button:not(:last-child) {
      margin-bottom: 1em;
    }
  }
    ${Button} {
      width:100%;
    }
`